import Route from "@ember/routing/route";
import type RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";

export default class NotFoundRoute extends Route {
  @service declare router: RouterService;

  override beforeModel() {
    this.router.transitionTo("/");
  }
}
